export default "__VITE_ASSET__AY7UmfMb__"